(function () {
  if (window.ChefSocialVideoCarousel) {
    window.ChefSocialVideoCarousel.initAll();
    return;
  }

  var instances = new WeakMap();

  function initSection(section) {
    if (!section || instances.has(section)) return;

    var rail = section.querySelector('[data-chef-video-rail]');
    var prev = section.querySelector('[data-chef-video-prev]');
    var next = section.querySelector('[data-chef-video-next]');

    function updateArrows() {
      if (!rail || !prev || !next) return;
      var maxScroll = rail.scrollWidth - rail.clientWidth;
      prev.disabled = rail.scrollLeft <= 1;
      next.disabled = rail.scrollLeft >= maxScroll - 1;
    }

    function scrollRail(direction) {
      if (!rail) return;
      rail.scrollBy({
        left: direction * rail.clientWidth,
        behavior: 'smooth',
      });
    }

    function handlePrevClick() {
      scrollRail(-1);
    }

    function handleNextClick() {
      scrollRail(1);
    }

    function setCardPlaying(card, isPlaying) {
      if (!card) return;

      var video = card.querySelector('video');
      var button = card.querySelector('.chef-social-video__play');

      card.classList.toggle('is-playing', isPlaying);
      if (video) video.controls = isPlaying;
      if (button) button.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
    }

    function loadCardVideo(card) {
      if (!card) return null;

      var existingVideo = card.querySelector('video');
      if (existingVideo) return existingVideo;

      var media = card.querySelector('.chef-social-video__media, .chef-product-video__media');
      var template = card.querySelector('template[data-chef-video-template]');
      if (!media || !template || !template.content.firstElementChild) return null;

      var video = template.content.firstElementChild.cloneNode(true);
      media.insertBefore(video, media.firstElementChild);
      video.addEventListener('ended', handleVideoEnded);
      return video;
    }

    function pauseCard(card) {
      if (!card) return;

      var video = card.querySelector('video');
      if (video) video.pause();
      setCardPlaying(card, false);
    }

    function handleSectionClick(event) {
      var button = event.target.closest('.chef-social-video__play');
      if (!button) return;

      var card = button.closest('[data-chef-video-card]');
      var video = card ? loadCardVideo(card) : null;
      if (!video) return;

      section.querySelectorAll('video').forEach(function (item) {
        if (item !== video) {
          var itemCard = item.closest('[data-chef-video-card]');
          pauseCard(itemCard);
        }
      });

      setCardPlaying(card, true);
      video.play().catch(function () {
        setCardPlaying(card, false);
      });
    }

    function handleVideoEnded(event) {
      setCardPlaying(event.target.closest('[data-chef-video-card]'), false);
    }

    function cleanup() {
      if (prev) prev.removeEventListener('click', handlePrevClick);
      if (next) next.removeEventListener('click', handleNextClick);
      if (rail) rail.removeEventListener('scroll', updateArrows);
      window.removeEventListener('resize', updateArrows);
      section.removeEventListener('click', handleSectionClick);
      section.querySelectorAll('video').forEach(function (video) {
        video.removeEventListener('ended', handleVideoEnded);
        pauseCard(video.closest('[data-chef-video-card]'));
      });
      instances.delete(section);
    }

    if (prev) prev.addEventListener('click', handlePrevClick);
    if (next) next.addEventListener('click', handleNextClick);
    if (rail) rail.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    section.addEventListener('click', handleSectionClick);
    section.querySelectorAll('video').forEach(function (video) {
      video.addEventListener('ended', handleVideoEnded);
    });
    instances.set(section, cleanup);
    updateArrows();
  }

  function cleanupSection(section) {
    var cleanup = instances.get(section);
    if (cleanup) cleanup();
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-chef-social-video-section]').forEach(initSection);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-chef-social-video-section]').forEach(cleanupSection);
  });

  window.ChefSocialVideoCarousel = {
    initAll: initAll,
    cleanupSection: cleanupSection,
  };
})();
